(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('RevisionEvaluativos', RevisionEvaluativos);

    RevisionEvaluativos.$inject = ['$resource'];

    function RevisionEvaluativos ($resource) {
        var resourceUrl =  'apo/revisionreportes:search,:type,:indice,:ic,:iic,:anio,:modelo,:nivel,:centro,:ep';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
